import { useRef, useState, useContext } from 'react';
import './App.css';
import Parent from './Parent';
import Header from './Header';
import { ThemeProvider } from './provider/ThemeProvider';
import ThemeWrapper from './ThemeWrapper';
import 'bootstrap/dist/css/bootstrap.min.css';
import ProductList from './ProductList';
import { CartProvider } from './provider/CartProvider';
import Home from './components/Home';

function App() {

  return (
    <>
     <Home />

    </>
  );
}

export default App;
